// extracted by mini-css-extract-plugin
export default {"analytics":"Analytics_analytics__SrXjz"};